import { StringTimeframeBuilder } from "./string-timeframe.builder";

export class StringTimeframe {
  public readonly begin: string;
  public readonly end: string;
  constructor(builder: StringTimeframeBuilder) {
    this.begin = builder.begin;
    this.end = builder.end;
  }
}
